import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, RequestOptions } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy, CurrencyPipe, registerLocaleData } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutes } from './app.routes';
import 'rxjs/add/operator/toPromise';
import { Http } from '@angular/http';
import { RoutePartsService } from './service/route-parts.service';
// import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { JwtHelper, AuthHttp } from 'angular2-jwt';

import { AccordionModule, AutoCompleteModule, ButtonModule, CalendarModule, InputMaskModule, CarouselModule, ColorPickerModule, ChartModule, CheckboxModule, ChipsModule, CodeHighlighterModule, ConfirmDialogModule, SharedModule, ContextMenuModule, DataGridModule, DataListModule, DataScrollerModule, DataTableModule, DialogModule, DragDropModule, DropdownModule, EditorModule, FieldsetModule, FileUploadModule, GalleriaModule, GMapModule, GrowlModule, InputSwitchModule, InputTextModule, InputTextareaModule, LightboxModule, ListboxModule, MegaMenuModule, MenuModule, MenubarModule, MessagesModule, MultiSelectModule, OrderListModule, OrganizationChartModule, OverlayPanelModule, PaginatorModule, PanelModule, PanelMenuModule, PasswordModule, PickListModule, ProgressBarModule, RadioButtonModule, RatingModule, ScheduleModule, SelectButtonModule, SlideMenuModule, SliderModule, SpinnerModule, SplitButtonModule, StepsModule, TabMenuModule, TabViewModule, TerminalModule, TieredMenuModule, ToggleButtonModule, ToolbarModule, TooltipModule, TreeModule, TreeTableModule, ConfirmationService } from 'primeng/primeng';

import { TextMaskModule, conformToMask } from 'angular2-text-mask';
import { UnmaskDirective } from './util/appUnmask.directive'

import { CurrencyMaskModule } from 'ng2-currency-mask'

import { DatatableService, AuthService, HttpService, AUTH_CONFIG, authServiceFactory, VersionTagModule } from '@basis/angular-components';

import { FormatSelectItemPipe } from './util/pipe-selecao';
import { LotacoesPipe } from './util/lotacoes.pipe';
import { CepPipe } from './util/pipe-cep';
import { PipeCpfCnpj } from './util/pipe-cpf-cnpj';

import { AppComponent } from './app.component';
import { AppMenuComponent, AppSubMenu } from './app.menu.component';
import { AppTopBar } from './app.topbar.component';
import { AppFooter } from './app.footer.component';
import { InlineProfileComponent } from './app.profile.component';

import { DatatableModule } from '@basis/angular-components';

import {TableModule} from 'primeng/table';

import { FilterUsuarioComponent, UsuarioComponent, CrudUsuarioComponent, CrudUsuarioEtapa1Component, CrudUsuarioEtapa2Component } from './usuario/';
import { CrudAlterarSenhaComponent, CrudAlterarSenhaEtapa1Component, CrudAlterarSenhaEtapa2Component } from './alterar-senha/';
import { ModulosComponent, CrudModulosSistemaComponent } from './modulos/';
import { LotacaoComponent, CrudLotacaoComponent, CrudLotacaoEtapa1Component, CrudLotacaoEtapa2Component, FilterLotacaoComponent } from './lotacao/';
import { LotacaoUsuarioComponent,FilterLotacaoUsuarioComponent, CrudLotacaoUsuarioComponent, CrudLotacaoUsuarioEtapa1Component, CrudLotacaoUsuarioEtapa2Component } from './lotacao-usuario/';
import { PerfilComponent,FilterPerfilComponent, CrudPerfilComponent, CrudPerfilEtapa1Component, CrudPerfilEtapa2Component } from './perfil/';
import { SistemaComponent,FilterGerenciarSistemaComponent, CrudSistemaComponent, CrudSistemaEtapa1Component, CrudSistemaEtapa2Component } from './sistema/';
import { FuncionalidadeComponent, CrudFuncionalidadeComponent, CrudFuncionalidadeEtapa1Component, CrudFuncionalidadeEtapa2Component, FilterFuncionalidadeComponent } from './funcionalidade/';
import { FuncionalidadePerfilComponent, CrudFuncionalidadePerfilComponent, CrudFuncionalidadePerfilEtapa1Component, CrudFuncionalidadePerfilEtapa2Component, FilterFuncionalidadePerfilComponent } from './funcionalidade-perfil/';
import { FuncionalidadeAcaoComponent, CrudFuncionalidadeAcaoCrudComponent } from './funcionalidade-acao/';
import { AcaoComponent, CrudAcaoComponent, CrudAcaoEtapa1Component, CrudAcaoEtapa2Component, FilterAcaoComponent } from './acao/';
import { MinhasPermissoesComponent, CrudMinhasPermissoesComponent, CrudMinhasPermissoesEtapa1Component, CrudMinhasPermissoesEtapa2Component, FilterMinhasPermissoesComponent } from './minhas-permissoes/';
import { GerenciarPermissoesComponent, CrudGerenciarPermissoesComponent, CrudGerenciarPermissoesEtapa1Component, CrudGerenciarPermissoesEtapa2Component, FilterGerenciarPermissoesComponent } from './gerenciar-permissoes/';
import { PermissoesPendentesComponent, CrudPermissoesPendentesComponent, CrudPermissoesPendentesEtapa1Component, CrudPermissoesPendentesEtapa2Component, FilterPermissoesPendentesComponent } from './permissoes-pendentes/';
import {CentralNotificacaoComponent,CrudCentralNotificacaoComponent,CrudCentralNotificacaoEtapa1Component,CrudCentralNotificacaoEtapa2Component, FilterCentralNotificacaoComponent} from './central-notificacao'

import { Locale } from './util/locale.ptbr';
import { Helpers } from './util/helpers';
import { BreadcrumbService } from 'ng5-breadcrumb';
import { CustomBreadcrumbComponent } from './util/custom-breadcrumb.component';
import { comparerStringRepeated, validateUF, ValidCpfORCnpj, validTitulo, requiredMinLength, requiredMaxLength } from './util/custom.validators';
import { PadraoService } from './service/padrao.service';

import { FormCalendarComponent, FormNumberCEPComponent, FormNumberCNPJComponent, FormNumberCPFComponent, FormHiddenComponent, FormMaskTextComponent, FormMoneyComponent, FormMultiSelectComponent, FormNumberComponent, FormPasswordComponent, FormPercentIpcaComponent, FormPercentComponent, FormRadioComponent, FormNumberRegistroComponent, FormSelectComponent, FormSliderComponent, FormSwitchComponent, TelefoneComponent, FormTextComponent, FormTextAreaComponent, TextBankAccountComponent, TextMaskBankComponent, ValidationComponent } from './base/base-fields/components/index';

import { BaseComponent, BaseCrudComponent, BaseCrudNavigationComponent, BaseCrudNavigationProfissionalComponent, BaseListFilterComponent, BaseInfoComponent, BaseStepComponent, BaseListComponent } from './base'
import { LotacaoService } from './util/obsevable-lotacao-user';
import { Erro403Component } from './erros';
import { AuthGuard } from "./autenticacao/auth.guard";
import { NgProgressModule } from 'ngx-progressbar'; 
import { BlockUIModule } from 'primeng/primeng';
import { BaseBarProgressComponent } from './base/base-barprogress.component';
import { ObservableUtil, ObservableBlockPanel, ObservableLotacao, ObservableVariable, bObservableUsuario, ObservableBlockPanelDoc } from './util/observable-util';
import { environment } from 'environments/environment';
import localePt from '@angular/common/locales/pt';
import { authHttpServiceFactory } from './autenticacao/auth.module';
import { TrilhaAuditoriaComponent, CrudTrilhaAuditoriaComponent, FilterTrilhaAuditoriaComponent, CrudTrilhaAuditoriaEtapa1Component, CrudTrilhaAuditoriaEtapa2Component, TrilhaAuditoriaRelatorioComponent, TrilhaAuditoriHistoricoComponent } from './trilha-auditoria';

registerLocaleData(localePt);

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutes,
    HttpModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    AccordionModule,
    AutoCompleteModule,
    ButtonModule,
    CalendarModule,
    CarouselModule,
    ColorPickerModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    CodeHighlighterModule,
    ConfirmDialogModule,
    SharedModule,
    ContextMenuModule,
    DataGridModule,
    DataListModule,
    DataScrollerModule,
    DataTableModule,
    DialogModule,
    DragDropModule,
    DropdownModule,
    EditorModule,
    FieldsetModule,
    FileUploadModule,
    GalleriaModule,
    GMapModule,
    GrowlModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    LightboxModule,
    ListboxModule,
    MegaMenuModule,
    MenuModule,
    MenubarModule,
    MessagesModule,
    MultiSelectModule,
    OrderListModule,
    OrganizationChartModule,
    OverlayPanelModule,
    PaginatorModule,
    PanelModule,
    PanelMenuModule,
    PasswordModule,
    PickListModule,
    ProgressBarModule,
    RadioButtonModule,
    RatingModule,
    ScheduleModule,
    SelectButtonModule,
    SlideMenuModule,
    SliderModule,
    SpinnerModule,
    SplitButtonModule,
    StepsModule,
    TabMenuModule,
    TabViewModule,
    TerminalModule,
    TieredMenuModule,
    ToggleButtonModule,
    ToolbarModule,
    TooltipModule,
    TreeModule,
    TreeTableModule,
    TableModule,
    TextMaskModule,
    CurrencyMaskModule,
    NgProgressModule,
    BlockUIModule,
    DatatableModule.forRoot(),
    VersionTagModule
  ],
  declarations: [
    FormatSelectItemPipe,
    LotacoesPipe,
    AppComponent,
    AppMenuComponent,
    AppSubMenu,
    AppTopBar,
    AppFooter,
    InlineProfileComponent,
    UnmaskDirective,
    BaseBarProgressComponent,

    FilterUsuarioComponent,
    UsuarioComponent,
    CrudUsuarioComponent,
    CrudUsuarioEtapa1Component,
    CrudUsuarioEtapa2Component,

    CrudAlterarSenhaComponent,
    CrudAlterarSenhaEtapa1Component,
    CrudAlterarSenhaEtapa2Component,

    ModulosComponent,
    CrudModulosSistemaComponent,

    LotacaoUsuarioComponent,
    FilterLotacaoUsuarioComponent,
    CrudLotacaoUsuarioComponent,
    CrudLotacaoUsuarioEtapa1Component,
    CrudLotacaoUsuarioEtapa2Component,

    PerfilComponent,
    FilterPerfilComponent,
    CrudPerfilComponent,
    CrudPerfilEtapa1Component,
    CrudPerfilEtapa2Component,

    LotacaoComponent,
    FilterLotacaoComponent,
    CrudLotacaoComponent,
    CrudLotacaoEtapa1Component,
    CrudLotacaoEtapa2Component,

    SistemaComponent,
    FilterGerenciarSistemaComponent,
    CrudSistemaComponent,
    CrudSistemaEtapa1Component,
    CrudSistemaEtapa2Component,

    FuncionalidadeComponent,
    FilterFuncionalidadeComponent,
    CrudFuncionalidadeComponent,
    CrudFuncionalidadeEtapa1Component,
    CrudFuncionalidadeEtapa2Component,

    FuncionalidadePerfilComponent,
    FilterFuncionalidadePerfilComponent,
    CrudFuncionalidadePerfilComponent,
    CrudFuncionalidadePerfilEtapa1Component,
    CrudFuncionalidadePerfilEtapa2Component,

    FuncionalidadeAcaoComponent,
    CrudFuncionalidadeAcaoCrudComponent,

    AcaoComponent,
    FilterAcaoComponent,
    CrudAcaoComponent,
    CrudAcaoEtapa1Component,
    CrudAcaoEtapa2Component,

    TrilhaAuditoriaComponent,
    CrudTrilhaAuditoriaComponent,
    FilterTrilhaAuditoriaComponent,
    CrudTrilhaAuditoriaEtapa1Component,
    CrudTrilhaAuditoriaEtapa2Component,
    TrilhaAuditoriaRelatorioComponent,
    TrilhaAuditoriHistoricoComponent,

    MinhasPermissoesComponent,
    FilterMinhasPermissoesComponent,
    CrudMinhasPermissoesComponent,
    CrudMinhasPermissoesEtapa1Component,
    CrudMinhasPermissoesEtapa2Component,

    GerenciarPermissoesComponent,
    FilterGerenciarPermissoesComponent,
    CrudGerenciarPermissoesComponent,
    CrudGerenciarPermissoesEtapa1Component,
    CrudGerenciarPermissoesEtapa2Component,

    PermissoesPendentesComponent,
    FilterPermissoesPendentesComponent,
    CrudPermissoesPendentesComponent,
    CrudPermissoesPendentesEtapa1Component,
    CrudPermissoesPendentesEtapa2Component,

    CentralNotificacaoComponent,
    FilterCentralNotificacaoComponent,
    CrudCentralNotificacaoComponent,
    CrudCentralNotificacaoEtapa1Component,
    CrudCentralNotificacaoEtapa2Component,

    BaseComponent,
    BaseCrudComponent,
    BaseCrudNavigationProfissionalComponent,
    BaseListFilterComponent,
    BaseCrudNavigationComponent,
    BaseInfoComponent,
    BaseStepComponent, 
    BaseListComponent,

    CustomBreadcrumbComponent,

    FormCalendarComponent,
    FormNumberCEPComponent,
    FormNumberCNPJComponent,
    FormNumberCPFComponent,
    FormHiddenComponent,
    FormMaskTextComponent,
    FormMoneyComponent,
    FormMultiSelectComponent,
    FormNumberComponent,
    FormPasswordComponent,
    FormPercentIpcaComponent,
    FormPercentComponent,
    FormRadioComponent,
    FormNumberRegistroComponent,
    FormSelectComponent,
    FormSliderComponent,
    FormSwitchComponent,
    TelefoneComponent,
    FormTextComponent,
    FormTextAreaComponent,
    TextBankAccountComponent,
    TextMaskBankComponent,
    ValidationComponent,

    CepPipe,
    PipeCpfCnpj,

    Erro403Component
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {provide: LOCALE_ID, useValue: 'pt'},
    {
      provide: DatatableService,
      useClass: DatatableService,
      deps: [AuthHttp]
    },
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    },
    {
        provide: AUTH_CONFIG,
        useValue: environment.auth
    },
    {
        provide: AuthService,
        deps: [HttpService, AUTH_CONFIG],
        useFactory: authServiceFactory
    },
     ObservableBlockPanel, ObservableLotacao, ObservableVariable, bObservableUsuario, ObservableBlockPanelDoc,
    // provideAuth({
    //   headerName: 'Authorization',
    //   headerPrefix: 'bearer',
    //   tokenName: 'token',
    //   tokenGetter: (() => localStorage.getItem('token')),
    //   globalHeaders: [{ 'Content-Type': 'application/json' }],
    //   noJwtError: true
    // }),
    RoutePartsService,
    ConfirmationService, 
    PadraoService, 
    FormatSelectItemPipe, 
    LotacoesPipe,
    BreadcrumbService, 
    AuthGuard, 
    CurrencyPipe, 
    LotacaoService,
    CepPipe,
    PipeCpfCnpj,
    Locale, 
    Helpers,
    JwtHelper,
    AuthService,
    HttpService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts